import { IQuestionEditorState } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import { IQuestionMetadata, IQuestionTag2 } from 'app_types/editor/questionTypes';
import React, { Component, CSSProperties } from 'react';
import { IQuestionEventType, ITermsAndConditions } from 'app_types/editor/questionTypes';

import { EditorPanelExerciseEditorLayout } from '../index'

interface IEditorPanelExerciseEditorComponentProps {
    question: IQuestionEditorState
    metadata?: IQuestionMetadata[]
    loading?: boolean
    editState: boolean
    tags?: IQuestionTag2[]
    hideDeleteButton?: boolean
    hideAddButton?: boolean
    hideFinishButton?: boolean
    hideViewButton?: boolean
    hideEditButton?: boolean
    hideTitle?: boolean
    showDeleteButton?: boolean
    children?: any
    className?: string
    style?: CSSProperties
    defaultCorrect?: boolean
    hideCorrectCheck?: boolean
    hideValueField?: boolean
    showRequiredCheck?: boolean
    hideFeedbackField?: boolean
    eventTypes?: IQuestionEventType[]
    termsAndConditions?: ITermsAndConditions[]
    showValidationSettings?: boolean
    isCharacterizationSurvey?: boolean
    onClickSave?: (resp: IQuestionEditorState) => void
    onClickDelete?: (question?: IQuestionEditorState) => void
    onQuestionSaved?: (status?: boolean) => void
    onQuestionDeleted?: (status?: boolean) => void
    onChangeQuestion?: (question?: IQuestionEditorState)=>void
    onClickEdit?: (question?: IQuestionEditorState)=>void
    onClickFinish?: ()=>void
    onClickView?: (question: IQuestionEditorState)=>void
}

interface IEditorPanelExerciseEditorComponentState {}

class EditorPanelExerciseEditorComponent extends Component<IEditorPanelExerciseEditorComponentProps, IEditorPanelExerciseEditorComponentState> {
    render() {
        return (
            <EditorPanelExerciseEditorLayout
                {...this.props}
            />
        );
    }
}

export default EditorPanelExerciseEditorComponent;
